import ProductTrack from 'umg-ember-backend/components/record-explorer/for/product-track';

<template>
  <ProductTrack @records={{@model}} @recordType='product-track' />
</template>
